import { call, put, takeEvery, getContext } from "redux-saga/effects";

import { addEmailFailure, addEmailSuccess } from "./actions";
import { addEmailActionTypes } from "./actionTypes";
import { CONTEXT } from "@const/redux";
import { localstorageKeys } from "@const/store";

const addEmailAsync = ({ SocialsService, email }) => {
  if (!SocialsService) {
    console.log("Required services does not exist");
    return null;
  }

  return SocialsService.addEmail({ email });
};

function* addEmail({ payload: { email } }) {
  try {
    const { SocialsService, StorageService } = yield getContext(
      CONTEXT.SERVICES,
    );
    const authSession = StorageService.get(localstorageKeys.authSession, null);
    if (authSession) {
      StorageService.set(localstorageKeys.session, authSession);
    }
    yield call(addEmailAsync, { SocialsService, email });
    yield put(addEmailSuccess());
  } catch ({ error }) {
    yield put(addEmailFailure(error));
  }
}

export function* watchAddEmail() {
  yield takeEvery(addEmailActionTypes.request, addEmail);
}
